import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { getScoreLetterFromScoreVenueDates } from '@/domain/impact-calculate/utils/get-score-letter-from-score-venue-dates.ts';
import {
  CalculateVenueEnv,
  EMPTY_CALCULATE_VENUE_ENV,
} from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity.ts';

import { CalculateVenueEnvDto } from './dto.type';

export class CalculateVenueEnvMapper {
  static dtoToEntity(dto: CalculateVenueEnvDto): CalculateVenueEnv {
    const globalScore = Number.parseFloat(dto.score.toString());
    const globalMaxScore = Number.parseFloat(dto.maxScore.toString());
    const globalScoreLetter = getScoreLetterFromScore(
      globalScore / globalMaxScore,
    );
    return {
      global: {
        score: globalScore,
        maxScore: globalMaxScore,
        scoreLetter: globalScoreLetter,
      },
      structure: dto.structure
        ? {
            scoreLetter: getScoreLetterFromScore(
              dto.structure.score / dto.structure.maxScore,
            ),
            score: dto.structure.score,
            maxScore: dto.structure.maxScore,
            topics: {
              FOOD_BEVERAGES: {
                score: dto.structure.topics.FOOD_BEVERAGES.score,
                maxScore: dto.structure.topics.FOOD_BEVERAGES.maxScore,
                sections: {
                  CATERING: {
                    score:
                      dto.structure.topics.FOOD_BEVERAGES.sections.CATERING
                        .score,
                    maxScore:
                      dto.structure.topics.FOOD_BEVERAGES.sections.CATERING
                        .maxScore,
                  },
                  BEVERAGES: {
                    score:
                      dto.structure.topics.FOOD_BEVERAGES.sections.BEVERAGES
                        .score,
                    maxScore:
                      dto.structure.topics.FOOD_BEVERAGES.sections.BEVERAGES
                        .maxScore,
                  },
                  DISHES: {
                    score:
                      dto.structure.topics.FOOD_BEVERAGES.sections.DISHES.score,
                    maxScore:
                      dto.structure.topics.FOOD_BEVERAGES.sections.DISHES
                        .maxScore,
                  },
                },
              },
              RESOURCES_POLLUTION: {
                score: dto.structure.topics.RESOURCES_POLLUTION.score,
                maxScore: dto.structure.topics.RESOURCES_POLLUTION.maxScore,
                sections: {
                  WATER: {
                    score:
                      dto.structure.topics.RESOURCES_POLLUTION.sections.WATER
                        .score,
                    maxScore:
                      dto.structure.topics.RESOURCES_POLLUTION.sections.WATER
                        .maxScore,
                  },
                  ENERGY: {
                    score:
                      dto.structure.topics.RESOURCES_POLLUTION.sections.ENERGY
                        .score,
                    maxScore:
                      dto.structure.topics.RESOURCES_POLLUTION.sections.ENERGY
                        .maxScore,
                  },
                  WASTE_ECODESIGN: {
                    score:
                      dto.structure.topics.RESOURCES_POLLUTION.sections
                        .WASTE_ECODESIGN.score,
                    maxScore:
                      dto.structure.topics.RESOURCES_POLLUTION.sections
                        .WASTE_ECODESIGN.maxScore,
                  },
                  POLLUTION_LOCATION: {
                    score:
                      dto.structure.topics.RESOURCES_POLLUTION.sections
                        .POLLUTION_LOCATION.score,
                    maxScore:
                      dto.structure.topics.RESOURCES_POLLUTION.sections
                        .POLLUTION_LOCATION.maxScore,
                  },
                },
              },
              COMMUNICATION: {
                score: dto.structure.topics.COMMUNICATION.score,
                maxScore: dto.structure.topics.COMMUNICATION.maxScore,
                sections: {
                  PHYSICAL_COMMUNICATION: {
                    score:
                      dto.structure.topics.COMMUNICATION.sections
                        .PHYSICAL_COMMUNICATION.score,
                    maxScore:
                      dto.structure.topics.COMMUNICATION.sections
                        .PHYSICAL_COMMUNICATION.maxScore,
                  },
                  DIGITAL_COMMUNICATION: {
                    score:
                      dto.structure.topics.COMMUNICATION.sections
                        .DIGITAL_COMMUNICATION.score,
                    maxScore:
                      dto.structure.topics.COMMUNICATION.sections
                        .DIGITAL_COMMUNICATION.maxScore,
                  },
                },
              },
              PUBLIC_ENGAGEMENT: {
                score: dto.structure.topics.PUBLIC_ENGAGEMENT.score,
                maxScore: dto.structure.topics.PUBLIC_ENGAGEMENT.maxScore,
                sections: {
                  MOBILITY_STRATEGY: {
                    score:
                      dto.structure.topics.PUBLIC_ENGAGEMENT.sections
                        .MOBILITY_STRATEGY.score,
                    maxScore:
                      dto.structure.topics.PUBLIC_ENGAGEMENT.sections
                        .MOBILITY_STRATEGY.maxScore,
                  },
                  PUBLIC_INFORMATION: {
                    score:
                      dto.structure.topics.PUBLIC_ENGAGEMENT.sections
                        .PUBLIC_INFORMATION.score,
                    maxScore:
                      dto.structure.topics.PUBLIC_ENGAGEMENT.sections
                        .PUBLIC_INFORMATION.maxScore,
                  },
                },
              },
            },
          }
        : EMPTY_CALCULATE_VENUE_ENV.structure,
      dates: {
        score: dto.events?.score || 0,
        maxScore: dto.events?.maxScore || 0,
        scoreLetter: dto.events?.score
          ? getScoreLetterFromScoreVenueDates(dto.events.score)
          : '-',
      },
    };
  }
}
